var _ellipse, _ellipse2, _ellipse3, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCosmos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9234,
    cy: 28,
    rx: 5.35165,
    ry: 25.8663,
    stroke: "url(#paint0_linear)",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9233,
    cy: 27.9999,
    rx: 5.35165,
    ry: 25.8663,
    transform: "rotate(-120 27.9233 27.9999)",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9234,
    cy: 27.9999,
    rx: 5.35165,
    ry: 25.8663,
    transform: "rotate(-60 27.9234 27.9999)",
    stroke: "url(#paint2_linear)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7673,
    cy: 16.048,
    r: 1.78388,
    fill: "url(#paint3_linear)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3557,
    cy: 45.6605,
    r: 1.78388,
    fill: "url(#paint4_linear)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.798,
    cy: 22.4699,
    r: 1.78388,
    fill: "url(#paint5_linear)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9229,
    cy: 28.1784,
    r: 3.21099,
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.1987,
    y1: 4.68932,
    x2: 22.3803,
    y2: 5.25646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 30.1985,
    y1: 4.68929,
    x2: 22.3801,
    y2: 5.25643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.1986,
    y1: 4.68925,
    x2: 22.3802,
    y2: 5.2564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9021FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 41.5257,
    y1: 14.4404,
    x2: 39.1926,
    y2: 15.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32088B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 25.1141,
    y1: 44.0528,
    x2: 22.781,
    y2: 44.8708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32088B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 11.5565,
    y1: 20.8623,
    x2: 9.2234,
    y2: 21.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32088B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 29.2881,
    y1: 25.2847,
    x2: 25.0886,
    y2: 26.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#773AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32088B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmos);
export default __webpack_public_path__ + "static/media/cosmos.4b539b6786c78f86fa9a54b83bb45d3c.svg";
export { ForwardRef as ReactComponent };